import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'learn.public',
    path: 'cart',
    name: 'CartPage',
    component: () => import('@/app/M2701ShoppingCart/ShoppingCart/PgShoppingCart'),
    meta: { title: i18n.t('m2701.cartPage.title'), authenticated: true.valueOf, permissions: ['cart.viewOwn'] }
  },
  {
    portalGroup: 'learn.public',
    path: 'termsOfService',
    name: 'termsOfService',
    component: () => import('@/app/M2701ShoppingCart/PgPrivacyPolicy.vue'),
    meta: { title: i18n.t('m2701.filter.termsOfService') }
  },
  {
    portalGroup: 'learn.public',
    path: 'privacyPolicy',
    name: 'privacyPolicy',
    component: () => import('@/app/M2701ShoppingCart/PgTermsOfService.vue'),
    meta: { title: i18n.t('m2701.filter.privacyPolicy') }
  }
]
